import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '~/state/reducers';
import { userSlice } from '~/state/slices/userSlice';
import type { UserState } from '~/state/slices/userSlice';

/** The user being acted as: the same shape and reducers as the signed-in user, kept as its own slice. */
export type ActingAsState = UserState;

export const actingAsSlice = createSlice({
  name: 'actingAs',
  initialState: userSlice.getInitialState(),
  reducers: {
    setActingAsState: userSlice.caseReducers.setUserState,
    resetActingAsState: userSlice.caseReducers.resetUserState,
  },
});

// Action creators are generated for each case reducer function
export const { setActingAsState, resetActingAsState } = actingAsSlice.actions;

export const getActingAsState = (state: RootState) => state.actingAs;

export default actingAsSlice.reducer;
